import { render, staticRenderFns } from "./Addworkspace.vue?vue&type=template&id=f17311b8"
import script from "./Addworkspace.vue?vue&type=script&lang=js"
export * from "./Addworkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports